<template>
    <div id="animation-canvas" ref="el">
        <slot></slot>
    </div>
</template>

<script setup>
import anime from "animejs/lib/anime.es.js";
import { onBeforeUnmount, onMounted } from "vue";

const el = ref();
const props = defineProps({
    trees: { default: false, type: [Boolean] },
    family: { default: false, type: [Boolean] },
    car: { default: false, type: [Boolean] },
});

const animateTrees = () => {
    if (props.trees === false) {
        anime({
            targets: el.value.querySelectorAll(".tree"),
            translateY: 10,
            scale: 0.4,
            opacity: 0,
            delay: anime.stagger(100),
        });
    } else {
        anime({
            targets: el.value.querySelectorAll(".tree"),
            translateY: 0,
            scale: 1,
            opacity: 1,
            delay: anime.stagger(100),
        });
    }
};

const animateFamily = () => {
    if (props.family === false) {
        anime({
            targets: el.value.querySelectorAll("#family .person"),
            translateY: 10,
            opacity: 0,
            delay: anime.stagger(100),
        });
    } else {
        anime({
            targets: el.value.querySelectorAll("#family .person"),
            translateY: 0,
            opacity: 1,
            delay: anime.stagger(100),
        });
    }
};

let tl;
onMounted(() => {
    tl = anime.timeline({
        duration: 800,
        autoplay: false,
        duration: 1700,
    });

    tl.add({
        targets: el.value.querySelectorAll("#car"),
        translateY: 0,
        translateX: 0,
        opacity: 1,
        easing: "cubicBezier(0.270, 0.785, 0.160, 1)",
        duration: 1000,
    }).add({
        targets: el.value.querySelectorAll("#car .charger"),
        easeing: "easeOutExpo",
        translateY: 0,
        opacity: 1,
        delay: 500,
        duration: 200,
    });
});

const animateCar = () => {
    if (props.car === false) {
        tl.reverse();
    }

    tl.play();
};

watch(
    () => props.trees,
    () => animateTrees(),
);
watch(
    () => props.family,
    () => animateFamily(),
);
watch(
    () => props.car,
    () => animateCar(),
);

onBeforeUnmount(() => {
    anime({
        targets: el.value.querySelectorAll(".tree"),
        translateY: 10,
        scale: 0.4,
        opacity: 0,
        delay: anime.stagger(100),
        duration: 0,
    });
});
</script>
